/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VScheduledAppointment } from '../../models/v-scheduled-appointment';

export interface GetSchedulesAppointments$Plain$Params {
}

export function getSchedulesAppointments$Plain(http: HttpClient, rootUrl: string, params?: GetSchedulesAppointments$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VScheduledAppointment>>> {
  const rb = new RequestBuilder(rootUrl, getSchedulesAppointments$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VScheduledAppointment>>;
    })
  );
}

getSchedulesAppointments$Plain.PATH = '/Schedule';
